// SET LOADING
export const EXAMPLE_SET_LOADING = 'EXAMPLE_SET_LOADING'
// FECTH DATA
export const EXAMPLE_FETCH_SUCCESS = 'EXAMPLE_FETCH_SUCCESS'
export const EXAMPLE_FETCH_FAIL = 'EXAMPLE_FETCH_FAIL'
// ADD DATA
export const EXAMPLE_ADD_SUCCESS = 'EXAMPLE_ADD_SUCCESS'
export const EXAMPLE_ADD_FAIL = 'EXAMPLE_ADD_FAIL'
// SET EDIT DATA
export const EXAMPLE_GET_SUCCESS = 'EXAMPLE_GET_SUCCESS'
export const EXAMPLE_GET_FAIL = 'EXAMPLE_GET_FAIL'
// CLEAR EDIT DATA
export const EXAMPLE_CLEAR_SELECTED = 'EXAMPLE_CLEAR_SELECTED'
// UPDATE DATA
export const EXAMPLE_UPDATE_SUCCESS = 'EXAMPLE_UPDATE_SUCCESS'
export const EXAMPLE_UPDATE_FAIL = 'EXAMPLE_UPDATE_FAIL'

// 
// SPOTIFY
// 

// SET TOKEN
export const SPOTIFY_SET_TOKEN = 'SPOTIFY_SET_TOKEN'

// REMOVE TOKEN
export const SPOTIFY_REMOVE_TOKEN = 'SPOTIFY_REMOVE_TOKEN'

// SET WEB_PLAYER_STATUS
export const SPOTIFY_SET_WEB_PLAYER_STATUS = 'SPOTIFY_SET_WEB_PLAYER_STATUS'

// SET DEVICE
export const SPOTIFY_SET_DEVICE = 'SPOTIFY_SET_DEVICE'

// SET CONTROL_INITIALIZING
export const SPOTIFY_SET_CONTROL_INITIALIZING = 'SPOTIFY_SET_CONTROL_INITIALIZING'

// SET PLAYER_READY
export const SPOTIFY_SET_PLAYER_READY = 'SPOTIFY_SET_PLAYER_READY'

// SET PLAYLIST
export const SPOTIFY_SET_PLAYLIST = 'SPOTIFY_SET_PLAYLIST'
// REMOVE PLAYLIST
export const SPOTIFY_REMOVE_PLAYLIST = 'SPOTIFY_REMOVE_PLAYLIST'
// RESET_TRACK_NO
export const SPOTIFY_RESET_TRACK_NO = 'SPOTIFY_RESET_TRACK_NO'
// SET PLAY
export const SPOTIFY_SET_PLAY = 'SPOTIFY_SET_PLAY'
// SET NEXT
export const SPOTIFY_SET_NEXT = 'SPOTIFY_SET_NEXT'
// SET LOADING
export const SPOTIFY_SET_LOADING = 'SPOTIFY_SET_LOADING'
// SET ANSWER_OPTIONS
export const SPOTIFY_SET_ANSWER_OPTIONS = 'SPOTIFY_SET_ANSWER_OPTIONS'
// FECTH DATA
export const SPOTIFY_FETCH_SUCCESS = 'SPOTIFY_FETCH_SUCCESS'
export const SPOTIFY_FETCH_FAIL = 'SPOTIFY_FETCH_FAIL'
// ADD DATA
export const SPOTIFY_ADD_SUCCESS = 'SPOTIFY_ADD_SUCCESS'
export const SPOTIFY_ADD_FAIL = 'SPOTIFY_ADD_FAIL'
// SET EDIT DATA
export const SPOTIFY_GET_SUCCESS = 'SPOTIFY_GET_SUCCESS'
export const SPOTIFY_GET_FAIL = 'SPOTIFY_GET_FAIL'
// CLEAR EDIT DATA
export const SPOTIFY_CLEAR_SELECTED = 'SPOTIFY_CLEAR_SELECTED'
// UPDATE DATA
export const SPOTIFY_UPDATE_SUCCESS = 'SPOTIFY_UPDATE_SUCCESS'
export const SPOTIFY_UPDATE_FAIL = 'SPOTIFY_UPDATE_FAIL'

// UPDATE DRM
export const SPOTIFY_SET_DRM_SUPPORT = 'SPOTIFY_SET_DRM_SUPPORT'

// 
// PLAYER
// 

// SET PLAYERS
export const PLAYER_SET_PLAYERS = 'PLAYER_SET_PLAYERS'

// RESET PLAYERS
export const PLAYER_RESET_PLAYERS = 'PLAYER_RESET_PLAYERS'

// SET NEXT_PALYER
export const PLAYER_SET_NEXT_PALYER = 'PLAYER_SET_NEXT_PALYER'

// ADD SCORE
export const PLAYER_ADD_SCORE = 'PLAYER_ADD_SCORE'

// RESET SCORE
export const PLAYER_RESET_SCORE = 'PLAYER_RESET_SCORE'

// RESET SCORE_HISTORY
export const PLAYER_RESET_SCORE_HISTORY = 'PLAYER_RESET_SCORE_HISTORY'